<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/stuList' }"
          >学员管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>学员详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">基本信息</h3>
          <el-button
            @click="resetPassword"
            style="float: right; margin-bottom: 5px"
            type="primary"
            >重置密码</el-button
          >
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="basicInfo"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="name"
                label="学员昵称"
                align="center"
                min-width="110"
              ></el-table-column>
              <el-table-column
                prop="id"
                label="学员ID"
                align="center"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="birthday"
                label="出生日期"
                align="center"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="sex"
                label="性别"
                align="center"
                width="110"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-else-if="scope.row.sex == 2">女</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="signupDate"
                label="报名时间"
                align="center"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="expireDate"
                label="会员有效期"
                align="center"
                width="180"
                v-if="zxstatus != 4"
              >
              </el-table-column>
              <el-table-column prop="" label="积分" align="center" width="140">
                <div class="btnFlex" style="min-width: 85px">
                  <template>
                    <!-- slot-scope="scope" -->
                    <span style="padding-right: 10px">{{ totalScore }}</span>
                    <stuScore @stuScoreResult="editStuScore">积分</stuScore>
                  </template>
                </div>
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                align="center"
                min-width="130"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="filterByPhone(scope.row.phone)"
                    style="color: #1d90e6"
                    >{{ scope.row.phone }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="weixinId"
                label="微信号"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="rateTeacher"
                label="定级老师"
                align="center"
                width="100"
              ></el-table-column>
              <!-- <el-table-column
                prop="renewalTeacher"
                label="拉群续费号"
                align="center"
                width="120"
              ></el-table-column> -->
            </el-table>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">班级信息</h3>
          <stuAddClass
            @classResult="classChgHandle1"
            style="float: right; margin-bottom: 5px"
            type="primary"
            >关联班级</stuAddClass
          >
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="classData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="name"
                label="班级"
                align="center"
                min-width="110"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewClass(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="startTime"
                label="班级时间"
                align="center"
                min-width="140"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.beginTime }} 至
                    {{ scope.row.finishTime }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                prop="groupName"
                label="班级分组"
                align="center"
                width="130"
              ></el-table-column>
              <el-table-column
                prop="progress"
                label="课程进度"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.package != undefined">
                    {{ scope.row.package.progress }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="joinTime"
                label="学员入班时间"
                align="center"
                min-width="140"
              >
                <!-- {{
                      checkWeekDiff(
                        scope.row.joinTime,
                        scope.row.startTime,
                        scope.row.endTime,
                        scope.row.package.count
                      )
                    }} -->
                <template slot-scope="scope">
                  <span v-if="isWeek">
                    {{ scope.row.joinTime }}
                    <span v-if="scope.row.joinTimeOrder == 0"> (第1周) </span>
                    <span v-if="scope.row.joinTimeOrder != 0">
                      (第{{ scope.row.joinTimeOrder }}周)
                    </span>
                  </span>
                  <span v-if="!isWeek">{{ scope.row.joinTime }} </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="stuStartTime"
                label="学员课程时间"
                align="center"
                min-width="220"
              >
                <!-- checkWeekDiff(
                        scope.row.stuStartTime,
                        scope.row.startTime,
                        scope.row.endTime,
                        scope.row.package.count
                      ) -->
                <template slot-scope="scope">
                  <!-- v-if="isWeek" -->
                  <span
                    >{{ scope.row.stuStartTime }}

                    <span v-if="scope.row.stuStartTimeOrder == 0">(第1周)</span>
                    <span v-if="scope.row.stuStartTimeOrder != 0">
                      (第{{ scope.row.stuStartTimeOrder }}周)</span
                    >
                    至
                    {{
                      checkStuEndTime(
                        scope.row.stuEndTime,
                        scope.row.finishTime
                      )
                    }}
                  </span>
                  <!-- <span v-if="!isWeek"> </span> -->
                </template>
              </el-table-column>
              <!-- {{ scope.row.expireTag }} -->
              <el-table-column
                prop="status"
                label="在班状态"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <!-- <el-tag v-if="scope.row.status == 0" type="danger"
                    >到期</el-tag
                  > -->
                  <el-tag v-if="scope.row.status == 1" type="success"
                    >在营</el-tag
                  >
                  <el-tag v-else-if="scope.row.status == 2" type="gray"
                    >转班</el-tag
                  >
                  <el-tag v-else-if="scope.row.status == 5" type="danger"
                    >结课</el-tag
                  >
                  <el-tag v-else-if="scope.row.status == 4" type="primary"
                    >毕业</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                show-overflow-tooltip
                align="center"
                width="210"
                fixed="right"
              >
                <template slot-scope="scope">
                  <div class="btnFlex" style="min-width: 85px">
                    <!--
                    <el-button
                      type="info"
                      size="mini"
                      @click="editClassTime(scope.row)"
                      style="margin-right:10px"
                      :disabled = "scope.row.status==4"
                      icon="edit"
                    >编辑</el-button>
                    -->
                    <!-- :progressNum="scope.row.package.progress" -->
                    <stuChgTime
                      @editClassTime="editClassTimeConfrim"
                      :startTime="scope.row.beginTime"
                      :endTime="scope.row.finishTime"
                      :stuStartTime="scope.row.stuStartTime"
                      :stujoinTime="scope.row.joinTime"
                      :stuEndTime="scope.row.stuEndTime"
                      :currEditClassId="scope.row.classId"
                      :btnDisable="scope.row.status == 4"
                      :classCount="scope.row.package.count"
                      :progressNum1="scope.row.package.progress"
                      :expireDate="scope.row.expireDate"
                      :kcTime="scope.row.startTime"
                      :signupDate="signupDate"
                      :chgStart="true"
                      :joinTime1="true"
                      :chgEnd="true"
                      style="margin-right: 10px"
                      >编辑</stuChgTime
                    >
                    <stuAddClass
                      @classResult="classChgHandle"
                      :oldClass="scope.row.classId"
                      :btnDisable="scope.row.status == 4"
                      >转班</stuAddClass
                    >
                    <el-button
                      type="danger"
                      @click="delStu(scope.row)"
                      size="mini"
                      icon="delete"
                      style="margin-left: 10px"
                      >删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">特色课程信息</h3>
          <stuAddExtra
            @extraResult="addExtraHandle"
            style="float: right; margin-bottom: 5px"
          />
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="extraData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleExtraChange"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="id"
                label="特色课程ID"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="特色课程名称"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="level"
                label="级别"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="created_at"
                label="添加时间"
                align="center"
                min-width="240"
              ></el-table-column>
            </el-table>
            <el-button
              type="danger"
              icon="delete2"
              @click="delExtraForStu"
              style="margin-top: 5px"
              >删除</el-button
            >
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">学情统计</h3>
          <el-form :inline="true" label-width="150px" :model="formLearn">
            <el-form-item label="阅读记录:">
              <el-date-picker
                @change="dateNowChage"
                :disabled="otherDisable"
                clearable
                value-format="yyyy-MM-dd"
                v-model="formLearn.dateNow"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <br />
            <el-form-item label="班级名称:">
              <el-select
                :disabled="dateDisable"
                clearable
                style="width: 220px"
                v-model="className"
                @change="changeClass"
                @clear="clearUser"
              >
                <el-option
                  v-for="item in classData"
                  :key="item.classId"
                  :label="item.name"
                  :value="item.classId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="周数:">
              <el-select
                @change="changeWeek"
                v-model="formLearn.weekNum"
                clearable
                style="width: 220px"
                :disabled="dateDisable"
              >
                <el-option
                  v-for="item in getWeekData"
                  :key="item.course_id"
                  :label="`${item.name} ${item.date}`"
                  :value="item.course_id"
                >
                  <span>{{ item.name }} </span
                  ><span> {{ item.date }}</span></el-option
                >
              </el-select>
            </el-form-item>
            <br />
          </el-form>
          <div class="readTime">
            阅读时长：<span>{{ readTime | setHis }}</span>
          </div>
          <br />
          <div class="panel-content">
            <el-table
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              :data="readList"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="bookName"
                label="书籍名称"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="courseLevel"
                label="级别"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="courseName"
                label="课程名称"
                align="center"
                min-width="240"
              ></el-table-column>
              <el-table-column
                prop="originFinishedCount"
                label="原音"
                align="center"
                min-width="240"
              >
                <template slot-scope="scope"
                  >{{ scope.row.originFinishedCount }}遍
                </template>
              </el-table-column>
              <el-table-column
                prop="explainFinishedCount"
                label="讲解"
                align="center"
                min-width="240"
              >
                <template slot-scope="scope"
                  >{{ scope.row.explainFinishedCount }}遍
                </template>
              </el-table-column>
            </el-table>

            <div class="btnFlex" style="margin-top: 30px; float: left">
              <el-button
                type="primary"
                @click="exportoper"
                icon="el-icon-document"
                >导出</el-button
              >
            </div>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal"
              ></el-pagination>
            </div>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">设备信息</h3>
          <el-form :inline="true" label-width="150px" :model="forminformation">
            <el-form-item label="SN:">
              <el-select
                clearable
                style="width: 220px"
                v-model="forminformation.sn"
                @change="snChageAgin"
              >
                <el-option
                  v-for="item in informationData"
                  :key="item.name"
                  :value="item.clientId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="使用记录:">
              <el-date-picker
                @change="dateNowChageAgin"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                v-model="forminformation.dateNow"
              >
              </el-date-picker>
            </el-form-item>

            <br />
          </el-form>
          <h4>点读次数:{{ need }}</h4>
          <br />
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="tableData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="bookName"
                label="点读书籍"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="level"
                label="级别"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="courseName"
                label="课程名称"
                align="center"
                min-width="240"
              ></el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal2"
              ></el-pagination>
            </div>
          </div>
          <h4>跟读记录：{{ needFollow }}</h4>
          <br />
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="followRead"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column
                prop="bookName"
                label="书籍"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="text"
                label="跟读文本"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="url"
                label="跟读"
                align="center"
                min-width="240"
              >
                <template slot-scope="scope">
                    <audio class="aud" controls :src="scope.row.url" >
                    <!-- <source :src="scope.row.url" /> -->
                  </audio>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                label="分数"
                align="center"
                min-width="240"
              ></el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal1"
              ></el-pagination>
            </div>
          </div>
        </div>
      </Card> 
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">其他信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formStu" label-width="90px">
              <el-form-item label="设备信息:">
                <!--
                <a href="javascript:;" @click="viewDevice" style="color:#1d90e6">{{ formStu.sn }}</a>
                -->
                <p>{{ formStu.sn }}</p>
              </el-form-item>
              <br />
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formStu.remark"
                  type="textarea"
                  disabled
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 49%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { dateStrToMs, nowDateToNowStr, calcWeek } from "../commonEdu";
import stuAddExtra from "../componentsEdu/stuAddExtra";
import stuAddClass from "../componentsEdu/stuAddClass";
import stuChgTime from "../componentsEdu/stuChgTime";
import stuChgExpire from "../componentsEdu/stuChgExpire";
import stuScore from "../componentsEdu/stuScore";

import moment from "moment";
import { Pagination } from "element-ui";
export default {
  name: "detailStu",
  components: { stuAddExtra, stuAddClass, stuChgTime, stuChgExpire, stuScore },
  data() {
    return {
      disable: true,
      disabled: false,
      formLearn: {
        bookName: "",
        dateNow: "",
        weekNum: "",
        className: "",
      },
      forminformation: {
        dateNow: "",
        sn: "",
      },
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      queryParams1: {
        page: 1,
        pageSize: 20,
      },
      queryParams2: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      pageTotal1: 0,
      pageTotal2: 0,
      weekNow: "",
      className: this.className,
      value1: "",
      basicInfo: [],
      classData: [],
      readList: [],
      readReadyList: [],
      getTeacherList: [],
      needClass: "",
      getWeekData: [],
      tableData: [],
      informationData: [
        // {
        //   label: "设备1",
        //   name: "F6010A0A000002",
        // },
        // {
        //   label: "设备2",
        //   name: "E0000000000000",
        // },
      ],
      neweredlists: "",
      readTime: [],
      formStu: {
        sn: "",
        remark: "",
      },
      currId: "",
      extraData: [],
      extraMultyChose: [],
      zxstatus: "",
      expireDate1: "",
      totalScore: "",
      isWeek: false,
      signupDate: "",
      joinTimeOrder: "",
      stuStartTimeOrder: "",
      need: "",
      needFollow: "",
      followRead: [],
      getFollow: [],
      multipleSelection: [],
    };
  },
  filters: {
    setHis(readTime) {
      if (typeof readTime === "number") {
        if (readTime <= 0) {
          return "00小时00分钟00秒";
        } else {
          let hh = parseInt(readTime / 3600); //小时
          let shh = readTime - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (
            (hh < 10 ? "0" + hh : hh) +
            "小时" +
            (ii < 10 ? "0" + ii : ii) +
            "分钟" +
            (ss < 10 ? "0" + ss : ss) +
            "秒"
          );
        }
      } else {
        return "00小时00分钟00秒";
      }
    },
  },
  created() {
    this.featchTeacherList();
    this.fetchDetail();
    this.feachReadDetail();
    this.zxstatus = this.$route.query.status;
    this.dateNow();
    this.fetchReadyData();
    // this.fetchFollowRead();

    // this.updateTime()
  },
  computed: {
    dateDisable() {
      if (this.formLearn.dateNow) {
        var date = new Date(this.formLearn.dateNow);
        return date instanceof Date;
        // return  ? true : false;
      }
    },
    otherDisable() {
      if (this.className || this.formLearn.weekNum) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    handleSelectionChange(val) {
      console.log(val, "val--------");
      this.multipleSelection=val
      // this.multipleSelection.push(val);
    },
    // 获取绑定的SN设备
    getInformationData(phone, babyId, muserId) {
      let params = {
        action: "userMcList",
        data: {
          appId: this.$API.APPID,
          userId: muserId,
          babyId: babyId,
          phone: phone,
        },
      };
      console.log(params, "params======");
      this.$axios.post("/robot/mainctrls/mcbind", params).then((res1) => {
        console.log(res1.data.data, "res1------------");
        // for(let n=0;n<res1.data.data.length;n++){
        //   this.informationData=res1.data.data
        // }
        this.informationData=res1.data.data
        console.log(this.informationData,'this.informationData------');
      });
    },
    // 设备信息点读数据
    fetchReadyData() {
      let params2 = {
        appId: this.$API.APPID,
        // appId: "007cd3983760",
        stuId: this.stuId,
        // clientId: "F6010A0A000002",
        clientId:this.forminformation.sn,
        date: this.forminformation.dateNow,
        // date:'2021-4-8',
        types: Array("daily"),
      };
      this.$axios
        .post("/edu/eduAdmin/study/get_stp_study_info", params2)
        .then((response2) => {
          console.log(response2, "response=======");
          if (response2 != null) {
            this.readReadyList = response2.data.data;
            for (let i = 0; i < this.readReadyList.length; ++i) {
              this.tableData = this.readReadyList[i].list;
              this.need = this.readReadyList[i].pointCnt;
              if (this.readReadyList[i].pager != undefined) {
                this.pageTotal2 = this.readReadyList[i].pager.total;
              } else {
                this.pageTotal2 = 0;
              }
              this.loading = true;
            }
          }
        });
    },
    // 设备信息跟读数据
    fetchFollowRead() {
      let params3 = {
        appId: this.$API.APPID,
        // appId: "007cd3983760",
        stuId: this.stuId,
        clientId: this.forminformation.sn,
        date: this.forminformation.dateNow,
        // date: this.forminformation.dateNow,
        // date:'2021-05-07',
        types: Array("follow-reading"),
      };
      console.log(params3, "params3=======");
      this.$axios
        .post("/edu/eduAdmin/study/get_stp_study_info", params3)
        .then((res3) => {
          if (res3 != null) {
            this.getFollow = res3.data.data;
            for (let i = 0; i < this.getFollow.length; ++i) {
              this.followRead = this.getFollow[i].list;
              this.needFollow = this.getFollow[i].cnt;
              if (this.getFollow[i].pager != undefined) {
                this.pageTotal1 = this.getFollow[i].pager.total;
              } else {
                this.pageTotal1 = 0;
              }
            }
          }
        });
    },
    clearUser() {
      this.getWeekData = [];
    },
    changeClass(classId) {
      if (!classId) {
        (this.formLearn.weekNum = ""), (this.newData = []);
        this.readList = [];
      } else if (classId) {
        this.feachWeekList(String(classId));
      }
      // this.feachReadDetail();
    },
    changeWeek(courseId) {
      if (courseId) {
        this.feachReadDetail(String(this.className), courseId, "");
      }
    },
    dateNowChage(date) {
      if (!date) {
        this.formLearn.dateNow = "";
        this.readList = [];
      } else {
        this.feachReadDetail("", "", date);
      }
    },

    dateNowChageAgin(date) {
      if (date) {
        this.fetchReadyData();
        this.fetchFollowRead();
      }
    },
    snChageAgin() {
      this.fetchReadyData();
      this.fetchFollowRead();
    },
    dateNow() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期

      this.formLearn.dateNow = year + "-" + month + "-" + date;
      this.forminformation.dateNow = year + "-" + month + "-" + date;
      this.feachReadDetail();
    },
    setValueNull(val) {
      this.formLearn.weekNum = null;
    },
    input() {
      this.feachReadDetail();
    },
    testUser() {
      this.feachReadDetail();
    },
    testUserers() {
      this.feachReadDetail();
    },
    // 学情统计周数
    feachWeekList(classId) {
      if (classId) {
        this.stuId = `${this.$route.query.id}`;
        let params = {
          appId: this.$API.APPID,
          classId: classId.toString(),
          onlyValid: true,
          stuId: this.stuId,
        };
        this.$axios
          .post("/edu/eduAdmin/course/list_cls_update_date", params)
          .then((res) => {
            if (res != null) {
              this.getWeekData = res.data.data;
              this.newData = [];
              this.getWeekData.forEach((item, index) => {
                // debugger
                this.newData.push({
                  // currentWeek: `第${item.order + 1}周：`,
                  currentWeek: `第${item.order + 1}周：`,
                  currentDate: item.date,
                  courseId: item.course_id,
                  index: index,
                  curCourse: item.curCourse ? item.curCourse : "",
                  order: item.order,
                });
              });
              this.newData.forEach((item, index) => {
                if (item.curCourse && item.curCourse == true) {
                  this.weekNow = item.courseId;
                  this.formLearn.weekNum = item.courseId;
                }
              });
              if (this.formLearn.weekNum) {
                this.feachReadDetail(classId, this.weekNow);
              } else {
                this.feachReadDetail(classId, this.formLearn.weekNum, "");
              }
              this.loading = false;
            }
            this.loading = false;
          });
      }
    },
    // 学员详情数据
    fetchDetail() {
      if (this.$route.query.id != undefined) {
        this.currId = `${this.$route.query.id}`;
        this.basicInfo = [];
        let params = {
          appId: this.$API.APPID,
          id: this.currId,
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/stu/detail", params).then(
          (res) => {
            if (res != null) {
              let m = JSON.parse(res);
              let temp = {
                id: m.id,
                name: m.name,
                phone: m.phone,
                signupDate: m.signupDate,
                birthday: m.birthday,
                sex: m.sex,
                // totalScore: m.totalScore,
                weixinId: m.weixinId,
                expireTag: m.expireTag,
                rateTeacher: m.rateTeacher,
                renewalTeacher: m.renewalTeacher,
              };
              this.totalScore = m.totalScore;
              if (m.expireDate === "2121-01-01" || m.expireDate === null) {
                temp.expireDate = "永久有效";
              } else {
                temp.expireDate = m.expireDate + m.expireTag;
                temp.expireDate2 = m.expireDate;
                // temp.expireTag = ;
              }
              this.expireDate1 = m.expireDate;
              this.basicInfo.push(temp);
              this.formStu.remark = m.remark;
              this.classData = m.classList;
              this.signupDate = temp.signupDate;
              this.getInformationData(m.phone, m.babyId, m.userId);

              for (let i in this.classData) {
                if (this.classData[i].package != undefined) {
                  let periodTemp = "";
                  if (this.classData[i].package.period == 1) {
                    periodTemp = "日";
                  } else if (this.classData[i].package.period == 2) {
                    periodTemp = "周";
                  } else if (this.classData[i].package.period == 3) {
                    periodTemp = "月";
                  }
                  this.classData[
                    i
                  ].package.progress = `第${this.classData[i].package.progress}${periodTemp}`;
                }
              }
              if (m.extraCourse != undefined) {
                this.extraData = m.extraCourse;
              } else {
                this.extraData = [];
              }
              var vm = this;
              if (m.classList) {
                m.classList.forEach(function (i, v) {
                  if (i.endTime <= i.stuStartTime) {
                    vm.isWeek = false;
                  } else {
                    vm.isWeek = true;
                  }
                });
              }
            }
          }
        );
      }
    },
    // 学情统计数据
    feachReadDetail(classId, courseId, date) {
      this.stuId = `${this.$route.query.id}`;
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        stuId: this.stuId,
        courseId: courseId ? courseId.toString() : "",
        classId: classId ? classId.toString() : "",
        date: date,
      };
      if (this.formLearn.dateNow != "") {
        params.date = this.formLearn.dateNow;
      }
      if (this.className != "") {
        params.classId = classId;
      }
      if (this.formLearn.weekNum != "") {
        params.courseId = String(courseId);
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/edu/eduAdmin/study/fyd_stu_study_statistics", params)
        .then((res) => {
          console.log(res, "res=======");
          if (res != null) {
            if (res.data.data != undefined) {
              let getNew = [];
              for (let i in res.data.data.list) {
                getNew.push(res.data.data.list[i]);
              }
              this.getNew = getNew;
              this.getNew = getNew;
              this.readList = this.getNew;
              console.log(this.readList, "this.readList=========");
              this.readTime = res.data.data.readDuration;
              this.pageTotal = res.data.data.pager.total;
              this.loading = false;
            } else {
              return;
            }
          } else {
            this.loading = false;
            alert(res.data.msg);
          }
        });
    },
    // 学情统计数据导出
    exportoper() {
      // this.stuId = `${this.$route.query.id}`;
      // let params = {
      //   appId: this.$API.APPID,
      //   stuId: this.stuId,
      //   courseId: courseId,
      //   classId: String(classId),
      //   date: date,
      // };
      // if (this.formLearn.dateNow != "") {
      //   params.date = this.formLearn.dateNow;
      // }
      // if (this.className != "") {
      //   params.classId = classId;
      // }
      // if (this.formLearn.weekNum != "") {
      //   params.courseId = String(courseId);
      // }
      // params.pageSize = this.queryParams.pageSize;
      // params.page = this.queryParams.page;
      // this.$axios
      //   .post("/edu/eduAdmin/study/fyd_stu_study_statistics", params)
      //   .then((res) => {
      //     if (res.data.data != undefined) {
      //       let getNew = [];

      //       for (let i in res.data.data.list) {
      //         getNew.push(res.data.data.list[i]);
      //       }
      //       this.getNew = getNew;
      //       this.readList = this.getNew;
      //       this.readTime = res.data.data.readDuration;
      //       this.pageTotal = res.data.data.pager.total;
      //       this.loading = false;
      //     } else {
      //       this.loading = false;
      //       // alert(res.data.msg);
      //       return;
      //     }
      //   });
      require.ensure([], () => {
        const { export_json_to_excel } = require("./vendor/Export2Excel");
        const tHeader = ["书籍名称", "级别", "课程名称", "原音", "讲解"];
        // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "bookName",
          "courseLevel",
          "courseName",
          "originFinishedCount",
          "explainFinishedCount",
        ];
        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        var day =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        var dateStr = year + "" + month + "" + day;
        let datename = "学员阅读详情列表" + dateStr;

        console.log(this.multipleSelection,'this.multipleSelection------');
        // const list = this.readList;
        let list = [];
        if (this.multipleSelection.length > 0) {
          for (let ms = 0; ms < this.multipleSelection.length; ms++) {
            this.mts = this.multipleSelection;
            // console.log(this.mts, "this.mts-----");
            list.push(JSON.parse(JSON.stringify(this.mts[ms])));
            // list.push(JSON.parse(JSON.stringify(this.multipleSelection)))
            // console.log(list, "-------------------------------");
          }
        } else {
          list = JSON.parse(JSON.stringify(this.readList));
          
        }

        if(this.multipleSelection.length==0){
          alert('请选择要导出的数据')
          return
        }

        for (let n = 0; n < list.length; n++) {
          // 原音
            list[n].originFinishedCount = list[n].originFinishedCount + "遍";
            // 讲解
            list[n].explainFinishedCount = list[n].explainFinishedCount + "遍";
        }
        // console.log(list, "导出后的数据-------");
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, datename);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    featchTeacherList() {
      let params = {
        appId: this.$API.APPID,
        classId: "385",
        // stuId: this.stuId,
      };
      this.$axios
        .post("/edu/eduAdmin/class/get_class_or_group_list", params)
        .then((res) => {
          if (res.data.data != undefined) {
            if (res != null) {
              this.getTeacherList = res.data.data.list;
              this.loading = false;
            } else {
              this.loading = false;
              alert(res.data.msg);
            }
          }
        });
    },
    delStu(data) {
      // if (this.stuSelMultSelection.length == 0) {
      //   alert("请先选择学生");
      //   return;
      // }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除所选学生</li></ul>",
        onOk: () => {
          let stuIds = [];
          stuIds.push(this.currId);
          // for (let i in this.stuSelMultSelection) {
          //   stuIds.push(`${this.stuSelMultSelection[i].id}`);
          // }
          let params = {
            appId: this.$API.APPID,
            stuId: stuIds,
            classId: data.classId.toString(),
          };
          this.$axios
            .post("/edu/eduAdmin/class/stu_del", params)
            .then((response) => {
              if (response != null) {
                if (response.data.rc == 0) {
                  this.$Message.success("删除成功!");
                  this.fetchDetail();
                } else {
                  alert(response.data.err);
                }
              }
            });
        },
      });
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.feachReadDetail();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.feachReadDetail();
    },
    handleCurrentChange1(val) {
      this.queryParams1.page = val;
      this.fetchReadyData();
    },
    handleSizeChange1(val) {
      this.queryParams1.pageSize = val;
      this.fetchReadyData();
    },
    handleCurrentChange2(val) {
      this.queryParams2.page = val;
      this.fetchFollowRead();
    },
    handleSizeChange2(val) {
      this.queryParams2.pageSize = val;
      this.fetchFollowRead();
    },
    // 重置密码
    resetPassword() {
      if (this.$route.query.id != undefined) {
        this.stuId = `${this.$route.query.id}`;
        let params = {
          appId: this.$API.APPID,
          stuId: this.stuId,
        };
        this.$axios
          .post("/edu/eduAdmin/stu/reset_passwd", params)
          .then((res) => {
            // console.log(response);
            if (res != null) {
              // debugger
              alert("密码已重置，新密码为初始密码");
            }
          });
      }
    },
    confirmSubmit() {
      this.$router.push({
        name: "stulist",
      });
    },
    viewClass(cls) {
      this.$router.push({
        name: "addClass",
        query: {
          id: cls.classId,
          do: "view",
        },
      });
    },
    viewProcess(process) {
      // console.log(process);
    },
    viewDevice() {},
    filterByPhone(phone) {
      sessionStorage.setItem("stuListFilterByPhone", phone);
      this.$router.push({
        name: "stulist",
      });
    },
    // 积分
    editStuScore(val) {
      // debugger

      let stuId = `${this.$route.query.id}`;
      let remark = val.remark;
      let score = val.score;
      let params = {
        appId: this.$API.APPID,
        stuId: stuId,
        score: parseInt(score),
        remark: remark,
      };
      console.log(params, 47676877);

      this.$axios
        .post("/edu/eduAdmin/stu/modify_score", params)
        .then((response) => {
          if (response != null) {
            this.$Message.success("操作成功!");
            this.fetchDetail();
          }
        });
      // }
    },

    editClassTimeConfrim(val) {
      if (this.expireDate1 == null) {
        this.expireDate1 = "2121-01-01";
        var expireDate1 = dateStrToMs(this.expireDate1);
      } else {
        var expireDate1 = dateStrToMs(this.expireDate1);
      }
      let startTime = dateStrToMs(val.startTime);
      let effectStartTime = dateStrToMs(val.effectStartTime); //学员在班的开课时间
      let effectEndTime = dateStrToMs(val.effectEndTime); //课程结束时间
      let classEndTime = dateStrToMs(val.endTime); //班级结束时间
      let stujoinTime = dateStrToMs(val.stujoinTime); //入班时间
      let signupDate = dateStrToMs(this.signupDate); //报名时间
      // console.log(this.signupDate,'000000000000000')
      // debugger
      if (effectStartTime > effectEndTime) {
        alert("结课时间不允许早于学员在班的开课时间");
        return;
      } else if (effectStartTime < startTime) {
        alert("学员课程起始时间不允许早于班级起始时间");
        return;
      } else if (effectEndTime != classEndTime && effectEndTime > expireDate1) {
        alert("请选择在会员有效期内的结课时间");
        return;
      } else if (stujoinTime < signupDate) {
        // debugger
        alert("入班时间不允许早于学员的报名时间");
        return;
      } else if (stujoinTime > expireDate1) {
        // debugger
        alert("入班时间不允许晚于学员的会员有效期");
        return;
      } else {
        let params = {
          appId: this.$API.APPID,
          stuId: [this.currId],
          classId: `${val.currEditClassId}`,
          startTime: formatDate(effectStartTime, "yyyy-MM-dd"),
          endTime: formatDate(effectEndTime, "yyyy-MM-dd"),
          joinTime: formatDate(stujoinTime, "yyyy-MM-dd"),
        };
        this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_update", params).then(
          (res) => {
            if (res != null) {
              this.$Message.success("操作成功!");
              this.fetchDetail();
            }
          }
        );
      }
    },
    classChgHandle(oldClassId, clsArr) {
      // debugger
      let params = {
        appId: this.$API.APPID,
        stuId: [this.currId],
        oldClassId: oldClassId[0] || "",
        classId: clsArr.classId.toString(),
        joinTime: nowDateToNowStr(),
      };
      console.log(params);
      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_save", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchDetail();
          }
        }
      );
    },
    addExtraHandle(arr) {
      if (arr.length > 0) {
        let ids = [];
        for (let i in arr) {
          ids.push(String(arr[i].id));
        }
        let params = {
          appId: this.$API.APPID,
          stuId: [this.currId],
          extraCourse: ids,
        };
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/stu/extra_course_add",
          params
        ).then((res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchDetail();
          }
        });
      }
    },
    // 关联班级
    classChgHandle1(clsArr) {
      // debugger
      let params = {
        appId: this.$API.APPID,
        stuId: [this.currId],
        oldClassId: "",
        classId: clsArr.classId.toString(),
        joinTime: nowDateToNowStr(),
      };
      console.log(params);

      this.eduAxiosPostRequest("/edu/eduAdmin/class/stu_save", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchDetail();
          }
        }
      );
    },
    handleExtraChange(val) {
      this.extraMultyChose = val;
    },
    delExtraForStu() {
      if (this.extraMultyChose.length == 0) {
        alert("请先选择特色课程");
        return;
      }

      this.$Modal.confirm({
        title: "确认删除？",
        content: "请确认是否为此学生删除特色课程",
        onOk: () => {
          let ids = [];
          for (let i in this.extraMultyChose) {
            ids.push(`${this.extraMultyChose[i].id}`);
          }
          let params = {
            appId: this.$API.APPID,
            stuId: this.currId,
            extraCourse: ids,
          };
          this.eduAxiosPostRequest(
            "/edu/eduAdmin/stu/extra_course_delete",
            params
          ).then((res) => {
            if (res != null) {
              this.$Message.success("删除成功!");
              this.fetchDetail();
            }
          });
        },
      });
    },
    getNextWeek(now, index) {
      // eslint-disable-next-line no-undef
      var last7 = moment(now)
        .subtract("days", -7 * `${index}`)
        .format("YYYY-MM-DD");
      return last7;
    },
    /**
     * 描述
     * @date 2021-04-26
     * @param {any} joinTime // 入学时间
     * @param {any} startTime // 课程总开始时间
     * @param {any} endTime // 班级结束时间
     * @param {any} count // 总周数
     * @returns {any}
     */
    checkWeekDiff(joinTime, startTime, endTime, count) {
      // debugger
      var joinTimeDate = moment(joinTime).unix();
      var startTimeDate = moment(startTime).unix();
      var endTimeDate = moment(endTime).unix();
      if (joinTimeDate <= startTimeDate) {
        return 1;
      } else if (joinTimeDate >= endTimeDate) {
        return count;
      } else {
        // debugger
        var a = Math.abs(moment(startTime).diff(moment(joinTime), "days")); //算出两个日期差 课程总开始时间和入班时间
        // console.log(a/7, 'da/')
        // console.log(joinTime, 'TIme')
        if (joinTime != null && startTime != null) {
          if ((a / 7) % 1 != 0) {
            // console.log("不是整数");
            return Math.ceil(a / 7);
          } else if ((a / 7) % 1 === 0) {
            // console.log("是整数");
            return Math.ceil(a / 7) + 1;
          }
        } else {
          return "?";
        }
      }
    },
    checkWeek(joinTime, startTime) {
      let joinWeek = calcWeek(joinTime);
      let startWeek = calcWeek(startTime);
      if (joinWeek != null && startWeek != null) {
        if (joinWeek <= startWeek) {
          return 1;
        } else {
          return joinWeek - startWeek + 1;
        }
      } else {
        return "?";
      }
    },
    checkStuEndTime(stuEndTime, clsFinishTime) {
      let str = "";
      if (stuEndTime != null) {
        let stuEndTimeNum = dateStrToMs(stuEndTime);
        let classEndTimeNum = dateStrToMs(clsFinishTime);
        if (classEndTimeNum == stuEndTimeNum) {
          str = "班级毕业";
        } else {
          str = stuEndTime;
        }
        if (this.basicInfo[0]) {
          if (this.basicInfo[0].expireDate2 != null) {
            // console.log(this.basicInfo[0],'222')
            let stuExpireTimeNum = dateStrToMs(this.basicInfo[0].expireDate2);
            if (stuExpireTimeNum < stuEndTimeNum) {
              str = `会员有效期：(${this.basicInfo[0].expireDate2})`;
            }
          }
        }
      } else {
        return stuEndTime;
      }
      return str;
    },

    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            if (response.data.rc == "0") {
              if (
                address.indexOf("stu_update") != -1 ||
                address.indexOf("stu_save") != -1 ||
                address.indexOf("extra_course_add") != -1 ||
                address.indexOf("extra_course_delete") != -1
              ) {
                resolve(JSON.stringify(response.data));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";

.readTime {
  text-align: right;
}

.aud{
  // background: #000;
  // width: 48px;
  border: none;
  // background:#fff;
  // overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// detailStu.vue?6ef47eb3